<template>
  <el-pagination
    background
    @size-change="sizeChange"
    @current-change="currentChange"
    :current-page="from.pageNum"
    :page-size="from.pageSize"
    prev-text="上一页"
    next-text="下一页"
    layout="prev, pager, next"
    :total="totals">
  </el-pagination>
</template>

<script>
var _poi;
export default {
  name: 'elpage',
  props: {
    pagedata:{
      type: Object,
      default: {}
    },
    total: {
      type: Number,
      default: 0
    },
  },
  data: function () {
    return {
      from:{
        pageSize: 10,
        pageNum: 1,
      },
      totals:0
    }
  },
  computed: {

  },
  created () {
    _poi = this;
    this.initFormPick();
  },
  methods: {
    initFormPick(){
      this.from.pageSize = this.pagedata.pageSize;
      this.from.pageNum = this.pagedata.pageNum;
      this.totals = this.total;
    },

    // pageSize 改变时会触发
    sizeChange (pageSizes) {
      this.from.pageSize = pageSizes
      // 避免页数超过范围时发起多次请求
      if (pageSizes * (this.from.pageNum - 1) < this.totals) {
        this.currentChange(this.from.pageNum)
      }
    },
    // currentPage 改变时会触发
    currentChange (val) {
      this.$emit('current-change', val);
    },

  }
}
</script>

<style scoped>
  .el-pagination.is-background .el-pager .number,
  .el-pagination.is-background .el-pager .more{
    border-radius: 50%;
  }
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .btn-next{
    background: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/elPage/elpage.vue